import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './MultiLineEditableRenderer.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.editable
    ? _c(
        "InlineEdit",
        {
          attrs: {
            value: _vm.value,
            icon: _vm.icon,
            "pencil-style": "floating",
            placement: _vm.placement
          },
          on: { "save-requested": _vm.onSaveRequested },
          scopedSlots: _vm._u(
            [
              {
                key: "editor",
                fn: function(ref) {
                  var value = ref.value;
                  var input = ref.input;
                  var isFocused = ref.isFocused;
                  var isInvalid = ref.isInvalid;
                  var isLoading = ref.isLoading;
                  var blur = ref.blur;
                  var focus = ref.focus;
                  var confirm = ref.confirm;
                  var cancel = ref.cancel;
                  return _c("TextArea", {
                    attrs: {
                      value: value,
                      "is-focused": isFocused,
                      "is-invalid": isInvalid,
                      "is-loading": isLoading,
                      "submit-on-enter": _vm.submitOnEnter
                    },
                    on: {
                      confirm: confirm,
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        if (!$event.metaKey) {
                          return null
                        }
                        return confirm($event)
                      },
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape"
                          ])
                        ) {
                          return null
                        }
                        return cancel($event)
                      },
                      input: input,
                      blur: blur,
                      focus: focus
                    }
                  })
                }
              }
            ],
            null,
            false,
            3795490457
          )
        },
        [
          _vm._t("default", [
            _c("MultiLineRenderer", { attrs: { value: _vm.value } })
          ])
        ],
        2
      )
    : _c("MultiLineRenderer", { attrs: { value: _vm.value } })
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/MultiLineEditableRenderer.vue.js